import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import type { StateLayerProperties } from './StateLayer.types';

const THUMB_UNCHECKED = 16;
const THUMB_CHECKED = 24;
const TRACK_PADDING = 4;
const STATE_LAYER_SIZE = 40;

export const StateLayer = styled(Box, {
  shouldForwardProp: property =>
    !['isChecked', 'dataTest'].includes(property as string),
})<StateLayerProperties>(({ theme, isChecked }) => ({
  position: 'absolute',
  width: STATE_LAYER_SIZE,
  height: STATE_LAYER_SIZE,
  borderRadius: '50%',
  top: '50%',
  transform: 'translateY(-50%)',
  pointerEvents: 'none',
  transition: theme.transitions.create(['left', 'right', 'background-color'], {
    duration: 250,
    easing: theme.transitions.easing.easeInOut,
  }),
  backgroundColor: 'transparent',
  ...(isChecked
    ? {
        right: TRACK_PADDING - (STATE_LAYER_SIZE - THUMB_CHECKED) / 2,
        left: 'auto',
      }
    : {
        left: TRACK_PADDING + 2 - (STATE_LAYER_SIZE - THUMB_UNCHECKED) / 2,
        right: 'auto',
      }),
}));
